import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { deleteRequest } from 'src/utils/request';
import messages from 'src/pages/SetupPage/messages';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

const deleteFieldCategory = async (categoryUuid: string) => {
  const { data } = await deleteRequest<RequestSimplifiedData>(
    API.DELETE.deleteFieldCategory(categoryUuid),
  );
  return data;
};

export const useDeleteFieldCategory = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: deleteFieldCategory,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.fieldCategoryDeleted), 1000);
      client.invalidateQueries({ queryKey: [QUERY_KEYS.FIELD_CATEGORIES] });
    },
    onError: handleError,
  });
};
